"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionPauseActionType = exports.SubscriptionPauseCollectionBehavior = exports.SubscriptionUpdateType = void 0;
var SubscriptionUpdateType;
(function (SubscriptionUpdateType) {
    SubscriptionUpdateType["requestPause"] = "requestPause";
    SubscriptionUpdateType["requestUnpause"] = "requestUnpause";
    SubscriptionUpdateType["pause"] = "pause";
    SubscriptionUpdateType["unpause"] = "unpause";
    SubscriptionUpdateType["applyCoupon"] = "applyCoupon"; // user with active subscription applies a coupon
})(SubscriptionUpdateType = exports.SubscriptionUpdateType || (exports.SubscriptionUpdateType = {}));
var SubscriptionPauseCollectionBehavior;
(function (SubscriptionPauseCollectionBehavior) {
    SubscriptionPauseCollectionBehavior["void"] = "void";
    SubscriptionPauseCollectionBehavior["keepAsDraft"] = "keep_as_draft";
    SubscriptionPauseCollectionBehavior["markUncollectible"] = "mark_uncollectible";
})(SubscriptionPauseCollectionBehavior = exports.SubscriptionPauseCollectionBehavior || (exports.SubscriptionPauseCollectionBehavior = {}));
var SubscriptionPauseActionType;
(function (SubscriptionPauseActionType) {
    SubscriptionPauseActionType["pause"] = "pause";
    SubscriptionPauseActionType["unpause"] = "unpause";
})(SubscriptionPauseActionType = exports.SubscriptionPauseActionType || (exports.SubscriptionPauseActionType = {}));
//# sourceMappingURL=subscriptionUpdate.js.map